module.exports = __webpack_public_path__ + "img/tui-3.0269cc91.png";